// @ts-nocheck
import React, { useState } from 'react';

const Footer = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });
  
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const generateMailtoLink = () => {
    const subject = encodeURIComponent(`Contact Request from Website`);
    const body = encodeURIComponent(
      `Name: ${formData.firstName} ${formData.lastName}\n` +
      `Phone: ${formData.phone}\n` +
      `Email: ${formData.email}\n` +
      `Message: ${formData.message}\n\n` +
      `This message was sent from the Link Bridge Consulting website footer contact form.`
    );
    
    return `mailto:connect@Linkbridgellc.us?subject=${subject}&body=${body}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Check if all required fields are filled
    if (!formData.firstName || !formData.lastName || !formData.phone || !formData.email || !formData.message) {
      alert("Please fill all required fields");
      return;
    }
    
    // Open the user's email client with pre-filled information
    window.location.href = generateMailtoLink();
    
    // Mark form as submitted
    setFormSubmitted(true);
    
    // Reset form
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      message: ''
    });
  };

  return (
    <footer id="footer-section" className="bg-white py-8 md:py-12 relative z-10 shadow-lg">
      <div className="container mx-auto px-4">
        {/* Main section with contact form */}
        <div className="mb-10 md:mb-16 grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          <div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-3 md:mb-4">How Can We Be of Help?</h2>
          <p className="text-gray-500 text-lg md:text-xl mb-1">Your partner in start up success</p>
          <p className="text-gray-500 text-lg md:text-xl">Let's build your dream startup together!</p>
          
          {formSubmitted && (
            <div className="mt-4 p-4 bg-green-100 rounded-lg">
              <p className="text-green-700 font-medium">Thank you for reaching out! Your email client has been opened with your message details.</p>
            </div>
          )}
        </div>

          {/* Contact Form */}
          <div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label htmlFor="firstName" className="sr-only">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="First Name"
                    className="w-full border-b border-gray-300 py-2 focus:border-primary focus:outline-none"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="sr-only">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Last Name"
                    className="w-full border-b border-gray-300 py-2 focus:border-primary focus:outline-none"
                    required
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label htmlFor="phone" className="sr-only">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone Number"
                    className="w-full border-b border-gray-300 py-2 focus:border-primary focus:outline-none"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="sr-only">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Address"
                    className="w-full border-b border-gray-300 py-2 focus:border-primary focus:outline-none"
                    required
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="message" className="sr-only">Your Message</label>
                <input
                  type="text"
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your Message"
                  className="w-full border-b border-gray-300 py-2 focus:border-primary focus:outline-none"
                  required
                />
              </div>
              
              <div className="flex items-center justify-between">
                <button
                  type="submit"
                  className="bg-blue-700 text-white font-medium py-2 px-6 rounded-md hover:bg-blue-800 transition-colors duration-300 w-full md:w-auto"
                >
                  Submit
                </button>
                
                <a 
                  href="mailto:connect@Linkbridgellc.us" 
                  className="hidden md:inline-block text-gray-600 hover:text-blue-700 text-sm hover:underline ml-4"
                >
                  Or email us directly
                </a>
              </div>
            </form>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-8 mb-10 md:mb-16">
          {/* Quick Links */}
          <div className="mb-8 md:mb-0">
            <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 text-gray-900">Quick Links</h3>
            <ul className="space-y-3 md:space-y-4">
              <li><a href="#about" className="text-gray-700 hover:text-primary transition-colors duration-300">About Us</a></li>
              <li><a href="#support" className="text-gray-700 hover:text-primary transition-colors duration-300">Support</a></li>
              <li><a href="#services" className="text-gray-700 hover:text-primary transition-colors duration-300">Services</a></li>
              <li><a href="#pricing" className="text-gray-700 hover:text-primary transition-colors duration-300">Pricing</a></li>
              <li><a href="#terms" className="text-gray-700 hover:text-primary transition-colors duration-300">Terms of Use</a></li>
              <li><a href="#privacy" className="text-gray-700 hover:text-primary transition-colors duration-300">Privacy policy</a></li>
            </ul>
          </div>
          
          {/* Contact Us*/}
          <div className="mb-8 md:mb-0 md:-ml-16">
            <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 text-gray-900">Contact Us</h3>
            <ul className="space-y-5 md:space-y-6">
              <li className="flex">
                <div className="w-8 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <span className="text-gray-700 font-medium">+1-972-809-3645</span>
              </li>
              <li className="flex">
                <div className="w-8 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <span className="text-gray-700 font-medium break-all">Connect@Linkbridgellc.us</span>
              </li>
            </ul>
          </div>
          
          {/* Empty column for spacing when in desktop view */}
          <div className="hidden md:block"></div>
        </div>
        
        {/* Divider */}
        <hr className="border-gray-200 mb-6" />
        
        {/* Footer bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Social icons */}
          <div className="flex space-x-4 mb-6 md:mb-0">
            <a href="#" className="bg-gray-900 rounded-full p-2" aria-label="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
            <a href="#" className="bg-gray-900 rounded-full p-2" aria-label="Telegram">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.331 19.115c-.035 0-.069-.002-.102-.006-.707-.046-1.39-.247-2.02-.598-.966-.546-1.815-1.322-2.523-2.309-.765-1.057-1.3-2.275-1.542-3.523-.262-1.363-.153-2.668.318-3.813.47-1.145 1.321-2.064 2.544-2.741 1.168-.647 2.557-.873 4.046-.665 1.71.238 3.284 1.046 4.455 2.286 1.12 1.189 1.85 2.672 2.094 4.27.387 2.535-.584 4.934-2.584 6.387-1.73 1.255-3.979 1.653-6.068 1.141-.153-.038-.269-.16-.308-.313-.041-.154.011-.317.132-.417.218-.178.509-.346.879-.504l.068-.029c.374-.159.787-.356 1.184-.56.732-.376 1.255-.716 1.642-1.078.384-.358.546-.686.547-1.097 0-.223-.088-.438-.253-.65-.145-.188-.373-.378-.676-.562-.82-.5-1.733-.7-2.724-.602-.997.099-1.975.537-2.905 1.306-.897.74-1.548 1.688-1.872 2.729-.331 1.062-.262 2.176.205 3.3.459 1.103 1.221 1.919 2.275 2.429.36.173.751.274 1.164.3l.066.003c.34.015.66-.075.854-.239.212-.181.315-.439.288-.724-.031-.316-.24-.604-.588-.814-.255-.155-.596-.255-1.062-.31-.543-.065-.788-.276-.818-.7-.034-.464.243-.934.709-1.212.348-.207.737-.293 1.18-.261.444.033.864.167 1.282.41.357.208.605.481.759.835.154.355.196.747.124 1.163-.133.76-.661 1.416-1.539 1.901-.476.265-1.005.432-1.552.495l-.14.01zm5.612-13.452c-2.265-1.217-4.288-1.43-6.142-.645-1.435.606-2.586 1.743-3.328 3.272-.744 1.532-.953 3.26-.616 5.09.334 1.807 1.229 3.424 2.655 4.801.954.924 2.046 1.561 3.315 1.933 1.383.406 2.856.383 4.245-.068.079-.026.127-.102.143-.186.016-.086-.01-.16-.069-.221-.187-.193-.49-.362-.904-.511-.363-.13-.736-.199-1.104-.205h-.07c-1.28-.014-2.307-.653-3.066-1.908-.723-1.192-.932-2.514-.617-3.893.26-1.142.811-2.111 1.624-2.879.697-.66 1.5-1.088 2.299-1.239.583-.11 1.143-.085 1.677.075.536.161 1.03.454 1.456.865.067.065.156.089.238.067.083-.022.15-.082.18-.161.151-.401.27-.812.357-1.227.051-.237.086-.475.105-.71.02-.24.001-.453-.054-.63-.054-.177-.153-.333-.295-.47z"/>
              </svg>
            </a>
          </div>
          
          {/* Privacy and Terms links */}
          <div className="flex mb-6 md:mb-0">
            <a href="#privacy" className="text-gray-700 hover:text-primary transition-colors duration-300 mr-8">Privacy Policy</a>
            <a href="#terms" className="text-gray-700 hover:text-primary transition-colors duration-300">Term of use</a>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-4 md:mt-6 text-center md:text-left">
          <p className="text-gray-700 text-sm md:text-base">©2025 LinkBridgeConsulting. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;